import { useTranslations } from 'next-intl';
import { PrimaryCTA } from 'components/shared';
import CustomLink from 'components/shared/CustomLink';
import { ReactNode } from 'react';
import { CustomImage as Image } from '../..';
import styles from './index.module.css';

export const TradeInOffer = ({
  className,
  tradeInValue,
}: {
  className?: string;
  tradeInValue?: ReactNode;
}) => {
  const t = useTranslations('ring');

  return (
    <div
      className={
        className ? `${styles.tradeInOffer} ${className}` : styles.tradeInOffer
      }
    >
      <h3>{t('ring.productSelection.tradeInSection.title')}</h3>

      <p className="description">
        {/* {t('ring.productSelection.tradeInSection.modal.subHead')} */}
        {t('secondaryOffers.text.getUp')} {tradeInValue}{' '}
        {t('secondaryOffers.text.tradeCreditTowards')}
      </p>
      {/* both crops render; CSS toggles at 993px (useWindowSize is 0 on SSR) */}
      <div className="img-container">
        <Image
          src={'web_v2/offer_modal/trade.png'}
          fill
          alt="trade-in"
          className="img-desktop"
        />
        <Image
          src={'web_v2/offer_modal/trade_resp.png'}
          fill
          alt="trade-in"
          className="img-mobile"
        />
      </div>
      <div className="content">
        <p className="directions">
          {t('ring.productSelection.tradeInSection.modal.bulletHead')}
        </p>
        <br />
        <br />
        <h4>{t('ring.productSelection.tradeInSection.modal.bulletA.title')}</h4>
        <p>
          {t('ring.productSelection.tradeInSection.modal.bulletA.description')}
        </p>
        <br />
        <br />
        <h4>{t('ring.productSelection.tradeInSection.modal.bulletB.title')}</h4>
        <p>
          {t('ring.productSelection.tradeInSection.modal.bulletB.description')}
        </p>
        <br />
        <br />
        <p className="tip">
          <b> {t('ring.productSelection.tradeInSection.modal.tip.title')}</b>
          {t('ring.productSelection.tradeInSection.modal.tip.description')}
        </p>
        <br />
        <br />
        <h4>{t('ring.productSelection.tradeInSection.modal.bulletC.title')}</h4>
        <p>
          {t('ring.productSelection.tradeInSection.modal.bulletC.description')}
        </p>
        <br />
        <br />
        <h4>{t('ring.productSelection.tradeInSection.modal.bulletD.title')}</h4>
        <p>
          {t('ring.productSelection.tradeInSection.modal.bulletD.description')}
        </p>
        <br />
        <br />
        <h4>{t('ring.productSelection.tradeInSection.modal.bulletE.title')}</h4>
        <p>
          {t('ring.productSelection.tradeInSection.modal.bulletE.description')}
        </p>
        <br />
        <br />
        <p>{t('ring.productSelection.tradeInSection.modal.bulletE.shipText')}</p>
        <br />
        <br />
        <p className="country">
          <b>{t('secondaryOffers.content.unitedKingdom')}</b>
        </p>
        <p>
          {t('secondaryOffers.text.unitParkwayWay')}
          <br />
          {t('secondaryOffers.text.contact8081349514')}
        </p>
        <br />
        <br />
        <p className="country">
          <b>{t('secondaryOffers.content.unitedStates')}</b>
        </p>
        <p>
          {t('secondaryOffers.text.6052BandiniBlvd')}
          <br />
          {t('secondaryOffers.text.contact8003817934')}
        </p>
        <br />
        <br />
        <p className="country">
          <b>{t('secondaryOffers.content.europe')}</b>
        </p>
        <p>
          {t('secondaryOffers.text.pievuStrKarm')}
          <br />
          {t('secondaryOffers.text.contact80023371')}
        </p>
        <br />
        <br />
        <p className="country">
          <b>{t('secondaryOffers.content.india')}</b>
        </p>
        <p>
          {/* Ultrahuman, 1004, 2nd Floor, 9th Main Road, HSR Layout Sector 7,
          Bengaluru, Bengaluru Urban, Karnataka, 560102. */}
          {t('secondaryOffers.text.amChambers2nd')}
          <br />
          {t('secondaryOffers.text.contact18001028693')}
        </p>
        <br />
        <br />
        <p className="country">
          <b>{t('secondaryOffers.content.uae')}</b>
        </p>
        <p>
          {t('secondaryOffers.text.iqFulfillmentGeneral')}
          <br />
          {t('secondaryOffers.text.contact800035703249')}
        </p>
        <br />
        <br />
        <h4>{t('ring.productSelection.tradeInSection.modal.bulletF.title')}</h4>
        <p>
          {t('ring.productSelection.tradeInSection.modal.bulletF.description')}
        </p>
      </div>
    </div>
  );
};

const HsaFsaDataContent = [
  { keyBase: 'secondaryOffers.hsaFsaSteps.a', image: '1.png' },
  { keyBase: 'secondaryOffers.hsaFsaSteps.b', image: '2.png' },
  { keyBase: 'secondaryOffers.hsaFsaSteps.c', image: '3-1.png' },
];

export const HsaFsaOffer = ({ className }: { className?: string }) => {
  const t = useTranslations('ring');
  return (
    <div
      className={
        className ? `${styles.hsaFsaOffer} ${className}` : styles.hsaFsaOffer
      }
    >
      <h3>{t('secondaryOffers.subheading.useYourHsa')}</h3>

      <p className="description">{t('secondaryOffers.text.saveMoreYour')}</p>
      <div className="img-container">
        <Image
          src={'web_v2/offer_modal/hsa-fsa-modal-header.png'}
          fill
          alt="trade-in"
        />
      </div>
      <div className="content">
        <p className="directions">{t('secondaryOffers.text.howItWorks')}</p>
        <br />
        {/* ------ */}
        <br />

        {HsaFsaDataContent.map((item, index) => {
          return (
            <>
              <h4>
                <span className="caption">
                  {t('secondaryOffers.text.step')} {index + 1}
                </span>
                {t(`${item.keyBase}.title`)}
              </h4>
              <p>{t(`${item.keyBase}.description`)}</p>
              <div className="img-container">
                <Image
                  src={`web_v2/offer_modal/hsa-fsa/0${index + 1}.png`}
                  fill
                  alt="trade-in"
                />
              </div>
              <br />
            </>
          );
        })}

        <br />
        {/* ------ */}
        <br />
        <br />

        <p>
          {t('secondaryOffers.text.needHelpReach')}{' '}
          <a href="mailto:support@ultrahuman.com">support@ultrahuman.com</a>{' '}
          {t('secondaryOffers.text.weVeGot')}
        </p>
        <br />
        <br />

        <CustomLink href={'/hsa-fsa'} className="cta" passHref>
          <PrimaryCTA color="black">
            {t('secondaryOffers.primaryCTA.exploreNow')}
          </PrimaryCTA>
        </CustomLink>
      </div>
    </div>
  );
};

export const HeroDiscountOffer = ({
  className,
  product = 'ring-air',
}: {
  className?: string;
  product?: 'ring-air' | 'ring-pro';
}) => {
  const t = useTranslations('ring');
  const productName = product === 'ring-pro' ? 'Ring Pro' : 'Ring AIR';

  return (
    <div
      className={
        className
          ? `${styles.heroDiscountOffer} ${className}`
          : styles.heroDiscountOffer
      }
    >
      <h3>{t('secondaryOffers.subheading.recognizingHeroesWorld')}</h3>

      {/* <p className="description">
          {t('ring.productSelection.tradeInSection.modal.subHead')}
        </p> */}
      <div className="img-container">
        <Image
          src={'web_v2/hero/modal/SpecialPricing.jpg'}
          fill
          alt={t('secondaryOffers.image.alt.heroes')}
          className="img-desktop"
        />
        <Image
          src={'web_v2/hero/modal/SpecialPricing_Mobile.jpg'}
          fill
          alt={t('secondaryOffers.image.alt.heroes')}
          className="img-mobile"
        />
      </div>
      <div className="content">
        {/* <p className="directions">
            {t('ring.productSelection.tradeInSection.modal.bulletHead')}
          </p> */}
        {/* <br />
            <br /> */}
        {/* <h4>Heading A</h4> */}
        <p>{t('secondaryOffers.text.heroesDescription', { productName })}</p>
        <br />
      </div>
    </div>
  );
};

export const UltraWorkOffer = ({ className }: { className?: string }) => {
  const t = useTranslations('ring');

  return (
    <div
      className={
        className
          ? `${styles.ultraWorkOffer} ${className}`
          : styles.ultraWorkOffer
      }
    >
      <h3>{t('secondaryOffers.subheading.ultrawork')}</h3>

      <p className="description">
        {t('ring.productSelection.tradeInSection.modal.subHead')}
      </p>
      <div className="img-container">
        <Image
          src={'web_v2/offer_modal/ultrawork.png'}
          fill
          alt="ultra-work"
          className="img-desktop"
        />
        <Image
          src={'web_v2/offer_modal/ultrawork_resp.png'}
          fill
          alt="ultra-work"
          className="img-mobile"
        />
      </div>
      <div className="content">
        {/* <p className="directions">
            {t('ring.productSelection.tradeInSection.modal.bulletHead')}
          </p> */}
        {/* <br />
            <br /> */}
        <h4>{t('secondaryOffers.subheading.heading')}</h4>
        <p>{t('secondaryOffers.text.youPeriodicallyReceive')}</p>
        <br />
        <p>{t('secondaryOffers.text.youPeriodicallyReceive')}</p>
      </div>
    </div>
  );
};
